import {AxiosRequestConfig} from "axios"
import {API} from "services/Api";

const URL = "/usuarios/colaboradores";

let paramsGeral: AxiosRequestConfig = {
    withCredentials: true,
};

export const ColaboradorService =  {
    findAll: (params?: AxiosRequestConfig) => {
        paramsGeral = {...paramsGeral, ...params};
        return API.get(`${URL}`, paramsGeral);
    },
    findById: (id: string, params?: AxiosRequestConfig) => {
        paramsGeral = {...paramsGeral, ...params};
        return API.get(`${URL}/${id}`, paramsGeral);
    },
    create: (data: any, params?: AxiosRequestConfig) => {
        paramsGeral = {...paramsGeral, ...params};
        return API.put(`${URL}`, data, paramsGeral);
    },
    update: (data: any, params?: AxiosRequestConfig) => {
        paramsGeral = {...paramsGeral, ...params};
        return API.put(`${URL}`, data, paramsGeral);
    },
    delete: (id: string, params?: AxiosRequestConfig) => {
        paramsGeral = {...paramsGeral, ...params};
        return API.delete(`${URL}/${id}`, paramsGeral);
    }
}